/**
 * Provides campaign data based on the params passed by query string.
 *
 * @returns {Object}
 *
 * {Object}.campaignData {Object} campaing data from URL.
 *      Fields are filled from URL using the corresponding params
 *      taken from A SEPARATE CONFIG
 * [campaignData.utm_source] {String} Required if the campaign is provided
 * [campaignData.utm_medium] {String} Required if the campaign is provided
 * [campaignData.utm_term] {String}
 * [campaignData.utm_content] {String}
 * [campaignData.utm_campaign] {String} Required if the campaign is provided
 *
 *      E.g. %URL%?utm_source=1 gives {utm_source: "1"}
 *      (depending on A SEPARATE CONFIG for param names)
 */

import window from 'edge/platform/base/Window';
import queryString from 'query-string';
import campaignUrlParams from 'text!./config/campaignUrlParams.json';

var defaultConfig = {
    urlParams: JSON.parse(campaignUrlParams).campaign
};
var config = Object.assign({}, defaultConfig);

export default {
    $get: function $get() {
        // ---VARS---
        var CAMPAIGN_KEYS = Object.keys(config.urlParams);
        var campaignData = {};

        // ---LOGIC---
        // parse URL search params
        var searchParams = queryString.parse(window.location.search);
        // fill campaign params keys from URL search params
        CAMPAIGN_KEYS.forEach(function (CAMPAIGN_KEY) {
            // param names are taken from A SEPARATE CONFIG
            var paramFromUrl = searchParams[config.urlParams[CAMPAIGN_KEY]];

            if (paramFromUrl) {
                campaignData[CAMPAIGN_KEY] = paramFromUrl;
            }
        });

        // ---RETURN---
        return campaignData;
    },

    setUrlParamsConfig: function setUrlParamsConfig(urlParamsConfig) {
        config.urlParams = urlParamsConfig;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/campaign/CampaignDataService.js
// module id = 1025
// module chunks = 0